import { Button } from '@components/button';
import { classNames } from '@lib/classNames/classNames';
import { memo, useCallback } from 'react';

export const Product = memo(
  ({
    product,
    industriesFilter,
    productsFilter,
    onProductChange,
  }: {
    product: string;
    industriesFilter: string[];
    productsFilter: string[];
    onProductChange: (newProducts: string[], url: string) => void;
  }) => {
    const handleClick = useCallback(() => {
      const newSearchParams = new URLSearchParams();

      const newProducts = productsFilter?.includes(product)
        ? productsFilter.filter((value) => value !== product)
        : [...productsFilter, product];

      for (const industry of industriesFilter) {
        newSearchParams.append('industries', industry);
      }

      for (const product of newProducts) {
        newSearchParams.append('products', product);
      }

      const url = `/cases${newSearchParams.size ? `?${newSearchParams}` : ''}`;

      onProductChange(newProducts, url);
    }, [productsFilter, product, onProductChange, industriesFilter]);

    return (
      <Button
        type="button"
        onClick={handleClick}
        className={classNames({
          cls: 'bg-surface-base-secondary cursor-pointer rounded-lg px-4 py-2 text-sm leading-[1.13rem]',
          mods: {
            '!bg-[#62C84D]': productsFilter?.includes(product),
          },
        })}
      >
        {product}
      </Button>
    );
  },
);

Product.displayName = 'Product';
